import { appNotification } from "../components/common/notification";
import { GENERAL_SERVER_ERROR } from "../constants/config";
import { authenticatedFetch } from "./api";

export const getAgentsConfigs = (): Promise<Agent[] | null> => {
  return authenticatedFetch(
    import.meta.env.VITE_API_BASE_URL + "/system/options/agents",
    { method: "GET" }
  )
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.detail) {
        appNotification.error({
          message: "Retrieving system options:",
          description: data.detail,
        });
        return null;
      } else {
        return data.data as Agent[];
      }
    })
    .catch((err) => {
      appNotification.error({
        message: "Retrieving system options:",
        description: GENERAL_SERVER_ERROR,
      });
      return null;
    });
};
